import UserTableMainHelper from './users-table-main-helper';


const UserHelpers = {
    TableMain : UserTableMainHelper,
}

export default UserHelpers;